'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.prepareAllFilesQuery = exports.prepareUnfiledDocumentsQuery = exports.prepareQuery = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var prepareQuery = exports.prepareQuery = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(queryNodes, appContext) {
        var walker, binderQuery, binderLocatorWriter, optimizer, documentTypeSecurityOptimizerVisitor, securityNode, security, evaluateQuery;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        debug('preparing query');
                        walker = new _QueryNodeWalker2.default();

                        walker.defaultSkipData = true;
                        binderQuery = new (Function.prototype.bind.apply(_BinderQuery2.default, [null].concat([{ data: { binderId: appContext.binderId } }], (0, _toConsumableArray3.default)(queryNodes))))();

                        debug(binderQuery);

                        binderLocatorWriter = new _BinderLocatorWriterVisitor2.default(binderQuery);
                        _context.next = 8;
                        return walker.walk(binderQuery, binderLocatorWriter, appContext);

                    case 8:
                        optimizer = new _DocumentTypeOptimizerVisitor2.default(binderQuery);
                        _context.next = 11;
                        return walker.walk(binderQuery, optimizer, appContext);

                    case 11:

                        walker.defaultSkipChildren = false;
                        documentTypeSecurityOptimizerVisitor = new _DocumentTypeSecurityOptimizerVisitor2.default(binderQuery);
                        _context.next = 15;
                        return walker.walk(binderQuery, documentTypeSecurityOptimizerVisitor, appContext);

                    case 15:
                        securityNode = void 0;

                        if (!appContext.ignoreSecurity) {
                            _context.next = 20;
                            break;
                        }

                        securityNode = binderQuery;
                        _context.next = 24;
                        break;

                    case 20:
                        security = new _SecurityVisitor2.default(binderQuery);
                        _context.next = 23;
                        return walker.walk(binderQuery, security, appContext);

                    case 23:
                        securityNode = security.lastSecurityConditions;

                    case 24:
                        walker.defaultSkipData = false;
                        evaluateQuery = new _EvaluateQueryVisitor2.default(securityNode);
                        _context.next = 28;
                        return walker.walk(securityNode, evaluateQuery, appContext);

                    case 28:
                        return _context.abrupt('return', evaluateQuery.getFinalQuery());

                    case 29:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function prepareQuery(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var prepareUnfiledDocumentsQuery = exports.prepareUnfiledDocumentsQuery = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(appContext) {
        var unfiledDocumentsQuery, walker, security, securityNode;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        debug('preparing unfiled documents query');
                        unfiledDocumentsQuery = new _UnfiledDocumentsQuery2.default({
                            data: {
                                binderId: appContext.binderId,
                                documentId: appContext.documentId
                            }
                        });
                        walker = new _QueryNodeWalker2.default();
                        security = new _SecurityVisitor2.default(unfiledDocumentsQuery);
                        _context2.next = 6;
                        return walker.walk(unfiledDocumentsQuery, security, appContext);

                    case 6:
                        securityNode = security.lastSecurityConditions;
                        return _context2.abrupt('return', securityNode.toQueryFragment());

                    case 8:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function prepareUnfiledDocumentsQuery(_x3) {
        return _ref2.apply(this, arguments);
    };
}();

// allFilesQuery is an object from the database and must be reconstituted
// structure: {
//      userId: '<guid>'
//      binders: {
//          [binderId]: {
//              binderId: '<guid'>
//              rootQuery: '<serialized query>'
//              binderDaps: {
//                  [dapsId]: {
//                      id: '<guid>'
//                      query: '<serialized query'>
//                  }
//                  ...
//              }
//          }
//      },
//      userDaps: {
//          [dapsId]: {
//              id: '<guid'>
//              query: '<serialized query>'
//          }
//          ...
//      }
//  }


var prepareAllFilesQuery = exports.prepareAllFilesQuery = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(allFilesQueries, appContext) {
        var binderQueries, allFilesQueryNode, walker, binderLocatorWriter, documentTypeSecurityOptimizerVisitor, security, evaluateQuery;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        debug('preparing all files query');

                        binderQueries = _lodash2.default.map(allFilesQueries.binders, function (_ref4) {
                            var binderId = _ref4.binderId,
                                rootQuery = _ref4.rootQuery,
                                binderDaps = _ref4.binderDaps;

                            var deserializedJson = _jsonHelper2.default.parse((0, _stringify2.default)(rootQuery));
                            var queryNode = _QueryNodeRegistry2.default.reconstituteDeserializedJson(deserializedJson);
                            queryNode.isRootFolder = true;
                            var binderQuery = new _BinderQuery2.default({ data: { binderId: binderId } }, queryNode);
                            binderQuery.binderDaps = _lodash2.default.values(binderDaps);
                            return binderQuery;
                        });


                        appContext.userDaps = _lodash2.default.values(allFilesQueries.userDaps);

                        allFilesQueryNode = new (Function.prototype.bind.apply(_AllFilesQuery2.default, [null].concat((0, _toConsumableArray3.default)(binderQueries))))();
                        walker = new _QueryNodeWalker2.default();

                        walker.defaultSkipData = true;
                        binderLocatorWriter = new _BinderLocatorWriterVisitor2.default(allFilesQueryNode);
                        _context3.next = 9;
                        return walker.walk(allFilesQueryNode, binderLocatorWriter, appContext);

                    case 9:

                        walker.defaultSkipChildren = false;
                        documentTypeSecurityOptimizerVisitor = new _DocumentTypeSecurityOptimizerVisitor2.default(allFilesQueryNode);
                        _context3.next = 13;
                        return walker.walk(allFilesQueryNode, documentTypeSecurityOptimizerVisitor, appContext);

                    case 13:

                        walker.defaultSkipChildren = false;
                        security = new _SecurityVisitor2.default(allFilesQueryNode);
                        _context3.next = 17;
                        return walker.walk(allFilesQueryNode, security, appContext);

                    case 17:

                        walker.defaultSkipData = false;
                        evaluateQuery = new _EvaluateQueryVisitor2.default(security.queryNode);
                        _context3.next = 21;
                        return walker.walk(allFilesQueryNode, evaluateQuery, appContext);

                    case 21:
                        return _context3.abrupt('return', evaluateQuery.getFinalQuery());

                    case 22:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function prepareAllFilesQuery(_x4, _x5) {
        return _ref3.apply(this, arguments);
    };
}();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _BinderQuery = require('./engine/BinderQuery');

var _BinderQuery2 = _interopRequireDefault(_BinderQuery);

var _UnfiledDocumentsQuery = require('./engine/UnfiledDocumentsQuery');

var _UnfiledDocumentsQuery2 = _interopRequireDefault(_UnfiledDocumentsQuery);

var _AllFilesQuery = require('./engine/AllFilesQuery');

var _AllFilesQuery2 = _interopRequireDefault(_AllFilesQuery);

var _EvaluateQueryVisitor = require('./engine/EvaluateQueryVisitor');

var _EvaluateQueryVisitor2 = _interopRequireDefault(_EvaluateQueryVisitor);

var _BinderLocatorWriterVisitor = require('./engine/BinderLocatorWriterVisitor');

var _BinderLocatorWriterVisitor2 = _interopRequireDefault(_BinderLocatorWriterVisitor);

var _QueryNodeWalker = require('./engine/QueryNodeWalker');

var _QueryNodeWalker2 = _interopRequireDefault(_QueryNodeWalker);

var _jsonHelper = require('./jsonHelper');

var _jsonHelper2 = _interopRequireDefault(_jsonHelper);

var _QueryNodeRegistry = require('./QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

var _DocumentTypeOptimizerVisitor = require('./optimizer/DocumentTypeOptimizerVisitor');

var _DocumentTypeOptimizerVisitor2 = _interopRequireDefault(_DocumentTypeOptimizerVisitor);

var _DocumentTypeSecurityOptimizerVisitor = require('./optimizer/DocumentTypeSecurityOptimizerVisitor');

var _DocumentTypeSecurityOptimizerVisitor2 = _interopRequireDefault(_DocumentTypeSecurityOptimizerVisitor);

var _SecurityVisitor = require('./security/SecurityVisitor');

var _SecurityVisitor2 = _interopRequireDefault(_SecurityVisitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require('debug')('@complion:query:src:prepareQuery');